import { StudentLibrary } from "@axl-dev/school-sdk";
import { Button } from "antd";
import { useCallback } from "react";

import { useLoc, useRouter } from "@app/shared/lib/hooks";
import { DateTime } from "@app/shared/ui";

type Props = {
  library: StudentLibrary;
  buttonRef: React.RefObject<HTMLButtonElement | null>;
  buttonLabel?: string;
};

export const NavigateButton: React.FC<Props> = ({ library, buttonRef, buttonLabel }) => {
  const loc = useLoc();
  const { history } = useRouter();

  const libraryWillBeAvailableBtn = useCallback(
    (accessDate?: Date) => {
      return accessDate ? (
        <Button
          className="material-card-main-btn material-card-main-btn-wrap"
          disabled
          type="primary"
          data-testid="course-button"
        >
          <span>{loc.word("School.contentItem.willBeAvailable", { default: "Will be available" })}</span>
          <DateTime date={accessDate} format="lll" />
        </Button>
      ) : (
        <Button
          className="material-card-main-btn "
          disabled
          type="primary"
          data-testid="course-button"
        >
          {`${loc.word("StudentCourse.noAccessLabel", { default: "You do not have access to this course" })}`}
        </Button>
      );
    },
    [loc],
  );

  return (
    <div className="material-card-btns">
      {library.studentHasAccess ? (
        <Button
          ref={buttonRef}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            history.push(`/library/${library.id}`);
          }}
          className="material-card-main-btn"
          type="primary"
        >
          {buttonLabel || loc.word("Library.openMsg", { default: "Open" })}
        </Button>
      ) : (
        libraryWillBeAvailableBtn(library.studentAccessDate)
      )}
    </div>
  );
};
